import r from "./index983.js";
var e = Object.prototype, o = e.hasOwnProperty;
function p(t) {
  var a = this.__data__;
  return r ? a[t] !== void 0 : o.call(a, t);
}
export {
  p as default
};
